export const MAP_BOUNDS = [-12900231.63426164, 3246498.818343048, -8536600.174951272, 6512287.786512453];

export const GEOSERVER_URL = process.env.GEOSERVER_URL || "";
